import { Component } from '@angular/core';
import { CustomerCreateModel, CustomerFilterModel, CustomerModel, CustomerServiceProxy } from '../../../../shared/service-proxies/event-service-proxy';
import { takeUntil } from 'rxjs';
import { ErrorService } from '../../../services/error/error.service';
import { ModalService } from '../../../services/modal/modal.service';
import { FilterService } from '../../../services/filter/filter.service';
import { DestroyService } from '../../../services/destroy/destroy.service';
import { TableColumn } from '../../../interfaces/table-column.interface';
import { Router } from '@angular/router';

@Component({
  selector: 'app-my-tasks-page',
  standalone: false,
  templateUrl: './my-tasks-page.component.html',
  styleUrl: './my-tasks-page.component.scss'
})
export class MyTasksPageComponent {
  public filter: CustomerFilterModel = new CustomerFilterModel();
  public customers: CustomerModel[] = [];
  public customerForm: CustomerCreateModel = new CustomerCreateModel();
  public columns: TableColumn[] = [
    { header: 'Клиент', fields: ['firstname', 'lastname'], col: 5 },
    { header: 'Создан', field: 'createdAt', col: 5 },
    { header: 'Менеджер', fields: ['user.firstname', 'user.lastname'], col: 5 },
    { header: 'Имейл', field: 'email', col: 5 },
    { header: '', field: 'status.name', col: 4, isPagination: true },
  ];

  isLoading: boolean = true;

  activeFilter: boolean = false;
  dataMissing: boolean|string = false;

  currentPage: number = 1;
  pageSize: number = 15;
  totalItems: number = 0;

  constructor(private errorService: ErrorService, private _customerServiceProxy: CustomerServiceProxy, public modalService: ModalService, private filterService: FilterService, private router: Router, private destroyService: DestroyService) {
  }
  ngOnInit() {
    this.getFilterState()
    this.getCustomers();
  }
  
  getCustomers() {
    this.filter.page = this.currentPage;
    this.filter.perPage = this.pageSize;
    this._customerServiceProxy.getByFilter(this.filter)
      .pipe(takeUntil(this.destroyService.onDestroy$))
      .subscribe((res) => {
        this.isLoading = false; 
            this.customers = res.items;
        this.totalItems = res.total;
        
      this.dataMissing = this.customers.length == 0;
    }, error => {
        console.error(error);
        this.isLoading = false;
        this.dataMissing = 'Не удалось получить список клиентов. Попробуйте позже.';
        
        this.errorService.handleError(error, 'Не удалось получить список клиентов. Попробуйте позже.');
    })
  }

  getFilterState() {
    const currentUrl = this.router.url;
    this.filterService.getFilterState(currentUrl)
      .pipe(takeUntil(this.destroyService.onDestroy$))
      .subscribe((state) => {
      this.activeFilter = state; 
    });
  }

  onPageChange(newPage: number): void {
    this.currentPage = newPage;
    this.getCustomers();
  }

  openModal(popup: string) {
    this.modalService.openModal(popup);
  }

  onFilterApply(filter: CustomerFilterModel): void {
    this.filter = filter;
    this.currentPage = 1; 
    this.getCustomers();
  }

  onFilterReset(): void {
    this.filter = new CustomerFilterModel(); 
    this.currentPage = 1; 
    this.getCustomers();
  }
}
